import fr from 'facet-rest';
import DateOrYearPickerFacetDesign from 'Components/ComponentLibrary/Molecules/dateOrYearPicker/facetDesign';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { metaOverrideSet as defaultFDModalMetaOverrideSet } from '../DefaultFDModal';

export default fr.metaOverride({ base: defaultFDModalMetaOverrideSet })
  .nameOverride('plannedRetirementDate', {
    _component: () => DateOrYearPickerFacetDesign,
    _customProps: {
      startDateField: 'dateOfBirth',
      isAge: true,
    },
  }, overrideReadOnly);
